
const Button=({name})=>{
    return(
     <button className="px-4 py-2 inline-block text-white  rounded-lg hover:bg-white hover:text-black   mx-4 my-2 bg-zinc-800 ">{name}</button>
    );
}
export default Button;